import { Link, useParams } from "react-router-dom";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import useTable from "../../../../MainComponents/Hooks/useTable";
import { useState } from "react";
import SendStudentsWhatsappMessages from "./SendStudentsWhatsappMessages";
import { useAuthState } from "../../../../MainComponents/GlobalContext";

const AdminViewCourse = () => {
  const AuthState = useAuthState();
  const { courseID } = useParams();

  const [showSendWhatsApp, setShowSendWhatsApp] = useState(false);

  // selections
  const [selectionActiveStudents, setSelectionActiveStudents] = useState([]);
  const [selectionLateStudents, setSelectionLateStudents] = useState([]);
  const [selectionAssignments, setSelectionAssignments] = useState([]);

  // view state control
  const [view, setView] = useState("active"); // "active" | "late" | "assignments"

  // selection handlers
  const handelSelectionActiveStudents = (records) => {
    if (!Array.isArray(records)) return;
    setSelectionActiveStudents(records.map((record) => ({ key: record.key })));
  };

  const handelSelectionLateStudents = (records) => {
    if (!Array.isArray(records)) return;
    setSelectionLateStudents(records.map((record) => ({ key: record.key })));
  };

  const handelSelectionAssignments = (records) => {
    if (!Array.isArray(records)) return;
    setSelectionAssignments(records.map((record) => ({ key: record.key })));
  };

  const tableActive = useTable(
    "viewCourse",
    "nested",
    "",
    "",
    "",
    courseID,
    "",
    "",
    "",
    "",
    handelSelectionActiveStudents
  );

  const tableLate = useTable(
    "viewCourseLateStudents",
    "",
    "",
    "",
    "",
    courseID,
    "",
    "",
    "",
    "",
    handelSelectionLateStudents
  );

  const tableAssignments = useTable(
    "viewAllStudentsAssignments",
    "",
    "",
    "",
    "",
    courseID,
    "",
    "",
    "",
    "",
    handelSelectionAssignments
  );

  const whatsappValidation =
    AuthState.userData?.admin?.permissions?.some((permission) =>
      permission.name.startsWith("send_whatsapp")
    ) || AuthState.userData?.admin?.roles[0]?.name === "superadmin";

  return (
    <section className="dark:bg-dark dark:text-light h-full w-full overflow-y-auto px-10 py-10 sm:px-4">
      <HelmetTags title={"Course View | Mr.Mohamed Salama"} />
      <h2 className="mb-7 text-start sm:text-center text-2xl font-bold">
        Course View
      </h2>

      {/* Action Buttons */}
      <div className="flex flex-wrap items-center gap-4 md:flex-col">
        {whatsappValidation && (
          <button
            className="w-fit rounded-2xl border-2 border-secondary bg-secondary px-3 py-1 text-center font-semibold text-bg duration-300 hover:bg-bg hover:text-secondary active:scale-90"
            disabled={
              (view === "active" && selectionActiveStudents.length === 0) ||
              (view === "late" && selectionLateStudents.length === 0) ||
              (view === "assignments" && selectionAssignments.length === 0)
            }
            onClick={() => setShowSendWhatsApp((prev) => !prev)}
          >
            {showSendWhatsApp ? "Back To Table" : "Send Whatsapp Messages"}
          </button>
        )}

        {/* Tabs */}
        <div className="flex gap-2">
          <button
            disabled={showSendWhatsApp}
            className={`rounded-2xl border-2 px-3 py-1 font-semibold duration-300 active:scale-90 ${
              view === "active"
                ? "bg-emerald-500 border-emerald-500 text-bg"
                : "border-secondary bg-bg text-secondary hover:bg-secondary hover:text-bg"
            }`}
            onClick={() => setView("active")}
          >
            Active Students
          </button>
          <button
            disabled={showSendWhatsApp}
            className={`rounded-2xl border-2 px-3 py-1 font-semibold duration-300 active:scale-90 ${
              view === "late"
                ? "bg-emerald-500 border-emerald-500 text-bg"
                : "border-secondary bg-bg text-secondary hover:bg-secondary hover:text-bg"
            }`}
            onClick={() => setView("late")}
          >
            Late Students
          </button>
          <button
            disabled={showSendWhatsApp}
            className={`rounded-2xl border-2 px-3 py-1 font-semibold duration-300 active:scale-90 ${
              view === "assignments"
                ? "bg-emerald-500 border-emerald-500 text-bg"
                : "border-secondary bg-bg text-secondary hover:bg-secondary hover:text-bg"
            }`}
            onClick={() => setView("assignments")}
          >
            All Assignments
          </button>
        </div>

        {AuthState.userData?.admin?.roles[0]?.name === "superadmin" && (
          <Link
            to={`/admin/courses/view/${courseID}/add-student`}
            className="w-fit rounded-2xl border-2 border-secondary bg-secondary px-3 py-1 text-center font-semibold text-bg duration-300 hover:bg-bg hover:text-secondary active:scale-90"
          >
            Add Student
          </Link>
        )}
      </div>

      {/* Table or WhatsApp Messages */}
      {showSendWhatsApp ? (
        <SendStudentsWhatsappMessages
          isActiveSutdents={view === "active" || view === "assignments"}
          selection={
            view === "active"
              ? selectionActiveStudents
              : view === "late"
                ? selectionLateStudents
                : selectionAssignments
          }
        />
      ) : (
        <div className="h-fit w-full">
          {view === "active" && tableActive}
          {view === "late" && tableLate}
          {view === "assignments" && tableAssignments}
        </div>
      )}
    </section>
  );
};

export default AdminViewCourse;
